module.exports = __webpack_public_path__ + "static/media/profile-page-background.b788ce83.png";